import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';

import { LangDroplistComponent } from './lang-droplist/lang-droplist.component';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [LangDroplistComponent],
  imports: [CommonModule, SharedUiComponentsModule, TranslocoModule],
  exports: [TranslocoModule, LangDroplistComponent],
})
export class LangComponentsModule {}
